import React from 'react';
import {
    TextMessage,
    ImageMessage,
    AudioMessage,
    VideoMessage,
    DocumentMessage,
    VoiceMessage
} from './messages';

// Componente principal que decide qué tipo de mensaje renderizar
const Message = (props) => {
    
    const { typeMessage } = props;
    
    // Selecciona el componente adecuado según el tipo de mensaje
    switch (typeMessage) {
        case 'image':
            return <ImageMessage {...props} />;
            
        case 'audio':
            return <AudioMessage {...props} />;
            
        case 'video':
            return <VideoMessage {...props} />;
            
        case 'document':
            return <DocumentMessage {...props} />;
            
        case 'voice':
            return <VoiceMessage {...props} />;
            
        // Para mensajes de texto o cualquier otro tipo no especificado
        case 'text':
        default:
            return <TextMessage {...props} />;
    }
};

export default Message;